import DaggerIcon from '../../icons/Personas/Dagger.svg'
import DaggerIconGrey from '../../icons/Personas/Dagger_Grey.svg'
import PropTypes from 'prop-types'

// Standalone dagger icon (not as superscript)
export const StandaloneDagger = ({width = 10, height = 10}) => {
  return <img src={DaggerIcon} alt="dagger symbol" style={{width, height}} />
}

// Dagger icon as superscript
export const SuperscriptDagger = ({width = 10, height = 10}) => {
  return (
    <sup>
      <img src={DaggerIcon} alt="dagger symbol" style={{width, height}} />
    </sup>
  )
}

// Dagger grey icon as superscript
export const SuperscriptGreyDagger = ({width = 10, height = 10}) => {
  return (
    <sup>
      <img src={DaggerIconGrey} alt="dagger symbol" style={{width, height}} />
    </sup>
  )
}

StandaloneDagger.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
}

SuperscriptDagger.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
}

SuperscriptGreyDagger.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
}
